/**
 * Brand logo component — renders the Three Little Birds mark.
 *
 * Variants:
 *   - "mark": birds-only (square-ish) — use in nav bars & compact spaces
 *   - "wordmark": full logo including the "PLAN · BUILD · LAUNCH" tagline
 *     — use on login page & hero surfaces
 *   - "text": legacy plain-text wordmark (kept for dark video overlays
 *     where a transparent PNG would clash)
 */
export default function Logo({ variant = "mark", className = "", height }) {
  const src = variant === "wordmark" ? "/logo.png" : "/logo-mark.png";
  const alt = "Three Little Birds";
  if (variant === "text") {
    return (
      <span
        className={`font-display font-black tracking-tighter ${className}`}
        data-testid="brand-wordmark-text"
      >
        three little birds
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={`brand-flutter ${className}`}
      style={height ? { height, width: "auto" } : undefined}
      data-testid={`brand-${variant}`}
      draggable={false}
    />
  );
}
